import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import {
  AgreementDetailsData,
  expectedYield,
  optimisticYield,
  pessimisticYield,
} from "../../../components/highcharts/AgreementDetailsData";
import { RiskLevel } from "@portal/types/robot/IRobotEnums";
import Typography from "@portal/components/atoms/v2/typography";

interface Props {
  riskLevel: RiskLevel;
  isDefaultLanguage: boolean;
}

export const AgreementGraph = ({ riskLevel, isDefaultLanguage }: Props) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <div className="mt-5 space-y-3">
      <Typography variant="Lead">{texts.PAGE_13_SAVINGS_RESULT_TITLE}</Typography>
      <div className="flex flex-col my-1 border rounded-md w-full p-1 bg-white h-[400px] ">
        <HighchartsReact highcharts={Highcharts} options={AgreementDetailsData(riskLevel ?? RiskLevel.Unknown)} />
      </div>
      <Typography variant="Body">
        {`${texts.PAGE_13_SAVINGS_RESULT.replace("$EXPECTED_YIELD", expectedYield(riskLevel).toString())
          .replace("$PESSIMISTIC_YIELD", pessimisticYield(riskLevel).toString())
          .replace("$OPTIMISTIC_YIELD", optimisticYield(riskLevel).toString())}`}
      </Typography>
    </div>
  );
};
